import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { SitecoreContextValue } from 'lib/ComponentProps';

// Temporary for demoing RCNi Learning in RCN Learn. If build proceeds RCNi Learning should
// have its own Page Template which can be detected via template ID.
// Function can be removed in RCNi Learning is not going to be part of RCN Learn.
export default function IsRcniLearningRoute(): boolean {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue & { itemPath: string }>();
	return sitecoreContext?.itemPath && sitecoreContext?.itemPath.toLocaleLowerCase().includes('rcni-learning') ? true : false;
}
